<h2 mat-dialog-title>Editar documento</h2>
<mat-dialog-content>
    <p>Editar el documento cancela las tareas pendientes, continuar?</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Cerrar</button>
    <button class="update-button" (click)="cerrarTareasDocumentoElaboracion()"
        [disabled]="fetchingCloseOpenDocumentNewTasks" mat-flat-button>
        <div class="btn-login-content">
            @if (fetchingCloseOpenDocumentNewTasks) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else{
            <p>Aceptar</p>
            }
        </div>
    </button>
</mat-dialog-actions>